import { routes as patientRoutes } from "./patients/routes";
import { routes as billPatientRoutes } from "./bill-patient/routes";
import { routes as receiveDepositRoutes } from "./receive-deposit/routes";
import { routes as receiptInvoiceRoutes } from "./receipt-invoice/routes";
import { routes as reversalRoutes } from "./reversals/routes";
import { routes as printRoutes } from "./prints/routes";
import { routes as consultantRoutes } from "./consultant-dashboard/routes";

import { routes as creditControlRoutes } from "../credit-control/routes";
import { routes as cashOutRoutes } from "../cash-out/routes";
import { routes as cancelUnpostedBillsRoutes } from "../cancel-unposted-bills/routes";
import { routes as approvalsRoutes } from "../approvals/routes";
import { routes as proformaRoutes } from "./proforma/routes";

export const routes = (prefix = `billing`) => [
    ...patientRoutes(),
    ...billPatientRoutes(),
    ...receiveDepositRoutes(),
    ...receiptInvoiceRoutes(),
    ...reversalRoutes(),
    ...printRoutes(),

    ...creditControlRoutes(prefix),
    ...cashOutRoutes(prefix),
    ...cancelUnpostedBillsRoutes(prefix),
    ...approvalsRoutes(prefix),
    ...consultantRoutes(),
    ...proformaRoutes(),
];
